import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from '../../Components/Button';
import Icon from '../../Components/Icon';
import InputManager from '../../Components/InputManager';
import FormManager from '../../Components/FormManager';

import Alert from '../../Components/Alert';

import { contactToUs } from '../../actions/contactUsForm';

import { validateEmail, validateMobile } from '../../helpers/helper';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      alertMessage: '',
      alertType: 'success',
      alertActive: false
    };
  }

  validateName = val => val.trim().length < 3;

  validateEmail = val => !validateEmail(val.trim());

  validatePhone = val => !validateMobile(val.trim());

  validateText = val => val.trim().length <= 0;

  toggleLoading = (status = false) => {
    this.setState({ isLoading: status });
  };

  onSubmit = async (data, resetForm) => {
    Object.assign(data, {
      message: data.city,
      origin: '300hrs'
    });
    try {
      this.toggleLoading(true);
      await this.props.contactToUs(data);
      this.toggleLoading(false);
      resetForm();
      this.showSuccessAlert();
    } catch (err) {
      this.toggleLoading(false);
      this.showFailedAlert();
    }
  };

  showAlert = () => {
    this.setState({
      alertActive: true
    });

    setTimeout(() => {
      this.removeAlert();
    }, 3000);
  };

  removeAlert = () => {
    this.setState({
      alertActive: false
    });
  };

  showSuccessAlert = () => {
    this.showAlert();
    this.setState({
      alertMessage:
        'Thank You for registering for 300+hrs. We will contact you soon.',
      alertType: 'success'
    });
  };

  showFailedAlert = () => {
    this.showAlert();
    this.setState({
      alertMessage: 'Something went wrong',
      alertType: 'failed'
    });
  };

  render() {
    const { alertMessage, alertType, alertActive } = this.state;

    return (
      <div className="th-reg-form">
        <FormManager onSubmit={this.onSubmit}>
          <InputManager
            primary
            id="name"
            placeholder="Full Name"
            validate={this.validateName}
            required={true}
            emptyText="Name is required"
            invalidText="Name must be atleast 3 characters"
          />

          <InputManager
            primary
            id="email"
            placeholder="Email Id"
            validate={this.validateEmail}
            required={true}
            emptyText="Email is required"
            invalidText="Invalid email"
          />

          <InputManager
            primary
            id="phone"
            placeholder="Phone Number"
            validate={this.validatePhone}
            required={true}
            emptyText="Phone number is required"
            invalidText="Invalid phone number"
          />

          <InputManager
            primary
            id="city"
            placeholder="City"
            validate={this.validateText}
            required={true}
            emptyText="City is required"
          />

          <Button
            className="th-reg-submit-btn"
            loading={this.state.isLoading}
            type="submit"
            text="REQUEST A CALLBACK"
          />
        </FormManager>
        <Alert visible={alertActive} type={alertType} title={alertMessage} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      contactToUs
    },
    dispatch
  );

const ConnectedForm = connect(
  null,
  mapDispatchToProps
)(Form);

const FormPoint = ({ children }) => {
  return (
    <div className="th-reg-form-point-box">
      <Icon className="th-reg-point-icon" name="fas fa-check-circle" />

      <span className="th-reg-point-text">{children}</span>
    </div>
  );
};

const RegistrationForm = () => {
  return (
    <div id="faq-reg-form" className="th-registration-container">
      <div className="th-reg-card">
        <div className="th-reg-desc">
          <span className="th-reg-form-title">
            Why should you pursue this
            <br />
            <span>300+ hrs Job guarantee program?</span>
          </span>

          <FormPoint>
            One on One dedicated
            <span className="th-reg-bold">mentorship</span>
          </FormPoint>

          <FormPoint>
            <span className="th-reg-bold">Custom designed</span>
            curriculum for every student
          </FormPoint>
          <FormPoint>
            Online and offline
            <span className="th-reg-bold"> Support </span>
            always available
          </FormPoint>
          <FormPoint>
            Among these
            <span className="th-reg-bold">30+ projects</span>, Work on real life
            use cases
          </FormPoint>
          <FormPoint>
            Most importantly, get a
            <span className="th-reg-bold">meaningful job </span>
            at the end of the program
          </FormPoint>
        </div>

        <ConnectedForm />
      </div>
    </div>
  );
};

export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/RegistrationForm.js